namespace SP {
    export async function postForm(postUrl: string, formQuerySelector: string, callback: (result: any) => any = null) {
        var form = document.querySelector(formQuerySelector) as HTMLFormElement;
        var formData = SP.serialize(form);
        const response = await fetch(postUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: formData
        });

        if (!response.ok) {
            //await SP.alertX("error posting form, check console!");
            console.log(response);
        }

        var result = await response.json();

        if (callback)
            callback(result);

        return result;
    }
}